import { Application } from "@hotwired/stimulus"
import ImageModalController from "./image_modal_controller"
import PublishController from "./publish_controller"
import SelectionController from "./selection_controller"
import TweetsController from "./tweets_controller"
import PublicationCountdownController from "./publication_countdown_controller"

const application = Application.start()
application.register("image-modal", ImageModalController)
application.register("hide-image", ImageModalController)
application.register("publish", PublishController)
application.register("selection", SelectionController)
application.register("tweets", TweetsController)
application.register("publication-countdown", PublicationCountdownController)
